import { render, staticRenderFns } from "./HabitableUnitCount.vue?vue&type=template&id=6d1468ee&"
import script from "./HabitableUnitCount.vue?vue&type=script&lang=ts&"
export * from "./HabitableUnitCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports